export default "__VITE_ASSET__IKOh_pj2__"